module.exports = __webpack_public_path__ + "static/integrations-creatives-06401f83e487008acf65b54edf2ff707.png";